import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { getSidebarData } from "../../data/json/sidebarData";
import ImageWithBasePath from "../imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import { setExpandMenu, setMobileSidebar } from "../../data/redux/commonSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { setDataSidebar } from "../../data/redux/themeSettingSlice";
import { AuthContext } from "../../../context/authcontext";
import { SidebarUniversalSearch } from "../../../components/filters/UniversalSearch";
import { useChatNotificationContext } from "../../../feature-module/application/components/chat/ChatNotificationContext";

const Sidebar = () => {
  const Location = useLocation();
  const dispatch = useDispatch();
  const dataSidebar = useSelector(
    (state: any) => state.themeSetting.dataSidebar
  );
  const miniSidebar = useSelector(
    (state: any) => state.commonSlice.miniSidebar
  );
  const DEFAULT_AVATAR =
    "https://cloudee-sales-crm-artifact.s3.ap-southeast-7.amazonaws.com/public-artifacts/user/male.png";
  const expandMenu = useSelector((state: any) => state.commonSlice.expandMenu);
  const { auth, selectedTenantId, lifecycleTypeNames } =
    useContext(AuthContext);
  const selectedTenant = auth?.tenants?.find(
    (t: any) => String(t.tenant_id) === String(selectedTenantId)
  );

  // Detect Super Admin - check if user has Super Admin role in any tenant
  const isSuperAdmin =
    auth?.tenants?.some(
      (t: any) =>
        t.role_key?.toLowerCase() === "superadmin" ||
        t.role_key?.toLowerCase() === "super_admin" ||
        t.role_name?.toLowerCase() === "superadmin" ||
        t.role_name?.toLowerCase() === "super_admin" ||
        t.role_key?.toLowerCase() === "platform_analyst" ||
        t.role_name?.toLowerCase() === "platformanalyst" ||
          t.role_key?.toLowerCase() === "apiadmin" ||
          t.role_key?.toLowerCase() === "api_admin" ||
          t.role_name?.toLowerCase() === "apiadmin" ||
          t.role_name?.toLowerCase() === "api_admin"
    ) || false;

  // Get user role - for Super Admin with no tenant selected, use the first Super Admin tenant's role
  let userRole = selectedTenant?.role_key || selectedTenant?.role_name || "";
  if (isSuperAdmin && !selectedTenantId) {
    const superAdminTenant = auth?.tenants?.find(
      (t: any) =>
        t.role_key?.toLowerCase() === "superadmin" ||
        t.role_key?.toLowerCase() === "super_admin" ||
        t.role_name?.toLowerCase() === "superadmin" ||
        t.role_name?.toLowerCase() === "super_admin" ||
        t.role_key?.toLowerCase() === "platform_analyst" ||
        t.role_name?.toLowerCase() === "platformanalyst" ||
          t.role_key?.toLowerCase() === "apiadmin" ||
          t.role_key?.toLowerCase() === "api_admin" ||
          t.role_name?.toLowerCase() === "apiadmin" ||
          t.role_name?.toLowerCase() === "api_admin"
    );
    userRole = superAdminTenant?.role_key || superAdminTenant?.role_name || "";
  }

  // Get tenant role for display - for Super Admin with no tenant selected, show Super Admin role
  let tenantRole = selectedTenant ? selectedTenant.role_name : "";
  if (
    selectedTenant?.team_manager &&
    (selectedTenant?.role_key?.toLowerCase() === "salesuser" ||
      selectedTenant?.role_key?.toLowerCase() === "sales_user" ||
      selectedTenant?.role_name?.toLowerCase() === "sales user")
  ) {
    tenantRole = "Team Manager";
  }
  if (isSuperAdmin && !selectedTenantId) {
    const superAdminTenant = auth?.tenants?.find(
      (t: any) =>
        t.role_key?.toLowerCase() === "superadmin" ||
        t.role_key?.toLowerCase() === "super_admin" ||
        t.role_name?.toLowerCase() === "superadmin" ||
        t.role_name?.toLowerCase() === "super_admin" ||
        t.role_key?.toLowerCase() === "platform_analyst" ||
        t.role_name?.toLowerCase() === "platformanalyst" ||
          t.role_key?.toLowerCase() === "apiadmin" ||
          t.role_key?.toLowerCase() === "api_admin" ||
          t.role_name?.toLowerCase() === "apiadmin" ||
          t.role_name?.toLowerCase() === "api_admin"
    );
    tenantRole = superAdminTenant?.role_name || "";
  }

  const sidebarData = getSidebarData(userRole, selectedTenantId);
  const { unreadCount } = useChatNotificationContext();

  const avatarUrl = auth?.avatar_url || DEFAULT_AVATAR;
  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");

  const getFilteredSidebarData = () => {
    return sidebarData;
  };

  // Helper function to close mobile sidebar if on mobile
  const closeMobileSidebarIfMobile = () => {
    if (window.innerWidth <= 991) {
      dispatch(setMobileSidebar(false));
    }
  };



  const toggleSidebar = (title: any, link?: string) => {
    // Only toggle if explicitly clicking the menu header
    if (title === subOpen) {
      localStorage.removeItem("menuOpened");
      setSubopen("");
    } else {
      localStorage.setItem("menuOpened", title);
      setSubopen(title);
    }

    // If this is a direct link (not a submenu), close mobile sidebar
    if (link) {
      closeMobileSidebarIfMobile();
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const toggle = () => {
    dispatch(setExpandMenu(true));
  };

  const toggle2 = () => {
    dispatch(setExpandMenu(false));
  };

  const handleSidebarClick = () => {
    dispatch(setDataSidebar("light"));
  };
  const leadsLabel = auth?.lifecycleTypeNames?.LEAD ?? "Leads";
  useEffect(() => {
    setSubopen(localStorage.getItem("menuOpened"));
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  return (
    <>
      <div
        className={`sidebar ${miniSidebar ? "mini-sidebar" : ""} ${expandMenu ? "expand-menu" : ""
          }`}
        id="sidebar"
        onMouseEnter={toggle}
        onMouseLeave={toggle2}
      >
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <>
              <div className="modern-profile p-3 pb-0">
                <div className="sidebar-nav mb-3">
                  <ul
                    className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <Link
                        className="nav-link active border-0"
                        to="#"
                        onClick={closeMobileSidebarIfMobile}
                      >
                        Menu
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link border-0 position-relative"
                        to={all_routes.chat}
                        onClick={closeMobileSidebarIfMobile}
                      >
                        Chats
                        {unreadCount > 0 && (
                          <span
                            className="badge rounded-pill bg-danger position-absolute"
                            style={{
                              top: '0px',
                              right: '10px',
                              fontSize: '10px',
                              padding: '2px 6px',
                              zIndex: 10
                            }}
                          >
                            {unreadCount > 99 ? "99+" : unreadCount}
                          </span>
                        )}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link border-0"
                        to={all_routes.email}
                        onClick={closeMobileSidebarIfMobile}
                      >
                        Inbox
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="sidebar-header p-3 pb-0 pt-2">
                <div className="d-flex align-items-center justify-content-between menu-item mb-3">
                  <div className="me-3">
                    <Link
                      to={all_routes.calendar}
                      className="btn btn-icon border btn-menubar"
                      onClick={closeMobileSidebarIfMobile}
                    >
                      <i className="ti ti-layout-grid-remove" />
                    </Link>
                  </div>
                  <div className="me-3">
                    <Link
                      to={all_routes.chat}
                      className="btn btn-icon border btn-menubar position-relative"
                      onClick={closeMobileSidebarIfMobile}
                    >
                      <i className="ti ti-brand-hipchat" />
                      {unreadCount > 0 && (
                        <span
                          className="badge rounded-pill bg-danger position-absolute"
                          style={{
                            top: '-5px',
                            right: '-5px',
                            fontSize: '10px',
                            padding: '2px 6px',
                            zIndex: 10
                          }}
                        >
                          {unreadCount > 99 ? "99+" : unreadCount}
                        </span>
                      )}
                    </Link>
                  </div>
                  <div className="me-3 notification-item">
                    <Link
                      to={all_routes.activities}
                      className="btn btn-icon border btn-menubar position-relative me-1"
                      onClick={closeMobileSidebarIfMobile}
                    >
                      <i className="ti ti-bell" />
                      <span className="notification-status-dot" />
                    </Link>
                  </div>
                  <div className="me-0">
                    <Link
                      to={all_routes.email}
                      className="btn btn-icon border btn-menubar"
                      onClick={closeMobileSidebarIfMobile}
                    >
                      <i className="ti ti-message" />
                    </Link>
                  </div>
                </div>
              </div>
            </>
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="clinicdropdown theme">
                  <Link
                    to={all_routes.profile}
                    onClick={closeMobileSidebarIfMobile}
                  >
                    <img
                      src={avatarUrl}
                      className="img-fluid rounded-circle"
                      style={{ width: 40, height: 40, objectFit: "cover" }}
                      alt="Profile"
                    />
                    <div className="user-names">
                      <h5>
                        {auth
                          ? `${auth.first_name} ${auth.last_name}`
                          : "Guest User"}
                      </h5>
                      <h6>{tenantRole || "No Role"}</h6>
                    </div>
                  </Link>
                </li>
              </ul>

              <ul>
                {/* Sidebar Universal Search - Mobile Only */}
                <div className="d-lg-none">
                  <SidebarUniversalSearch />
                </div>

                {getFilteredSidebarData()?.map((mainLabel, index) => (
                  <li className="clinicdropdown" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title: any, i) => {
                        const dynamicLabel =
                          title.lifecycleTypeKey &&
                            lifecycleTypeNames[title.lifecycleTypeKey]
                            ? lifecycleTypeNames[title.lifecycleTypeKey]
                            : title.label;
                        let link_array: any = [];
                        if ("submenuItems" in title) {
                          title.submenuItems?.forEach((link: any) => {
                            link_array.push(link?.link);
                            if (link?.submenu && "submenuItems" in link) {
                              link.submenuItems?.forEach((item: any) => {
                                link_array.push(item?.link);
                              });
                            }
                          });
                        }
                        title.links = link_array;

                        return (
                          <li className="submenu" key={title.label}>
                            <Link
                              to={title?.submenu ? "#" : title?.link}
                              onClick={() => {
                                if (title?.submenu) {
                                  toggleSidebar(title?.label, title?.link);
                                } else {
                                  localStorage.removeItem("menuOpened");
                                  setSubopen("");
                                  if (title?.link) {
                                    closeMobileSidebarIfMobile();
                                  }
                                }
                              }}
                              className={`${
                                subOpen === title?.label && title?.submenu ? "subdrop" : ""
                              }
  ${title?.links?.some((link: string) => Location.pathname.startsWith(link))
                                  ? "active"
                                  : ""
                                }
  ${title?.submenuItems?.some((link: { link: string }) =>
                                  Location.pathname.startsWith(link?.link)
                                ) ||
                                  (title?.link && title.link.includes("/application/email/")
                                    ? Location.pathname.startsWith("/application/email/")
                                    : Location.pathname.startsWith(title?.link)) ||
                                  // Dynamically check all subLinks
                                  Object.keys(title)
                                    .filter((key) => key.startsWith("subLink"))
                                    .some((key) => {
                                      const subLink = title[key];
                                      // Special handling for email routes
                                      if (subLink && subLink.includes("/application/email/")) {
                                        return Location.pathname.startsWith("/application/email/");
                                      }
                                      return Location.pathname.startsWith(subLink);
                                    })
                                  ? "active"
                                  : ""
                                }`}
                            >
                              <i className={title.icon}></i>
                              <span>{dynamicLabel}</span>
                              {title.label === "Chat" && unreadCount > 0 && (
                                <span
                                  className="badge rounded-pill bg-danger"
                                  style={{
                                    fontSize: '10px',
                                    padding: '2px 6px',
                                    marginLeft: '8px',
                                    height: '18px',
                                    lineHeight: '1',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: '18px'
                                  }}
                                >
                                  {unreadCount > 99 ? "99+" : unreadCount}
                                </span>
                              )}
                              <span
                                className={title?.submenu ? "menu-arrow" : ""}
                              />
                            </Link>
                            {title?.submenuItems && (
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map((item: any) => (
                                  <li
                                    className="submenu submenu-two"
                                    key={item.label}
                                  >
                                    <Link
                                      to={item?.link}
                                      className={`${item?.submenuItems
                                        ?.map((link: any) => link?.link)
                                        .some((link: string) =>
                                          Location.pathname.startsWith(link)
                                        ) ||
                                        Location.pathname.startsWith(
                                          item?.link
                                        ) ||
                                        // Check subLinks for this menu item
                                        Object.keys(item)
                                          .filter((key) =>
                                            key.startsWith("subLink")
                                          )
                                          .some((key) => {
                                            const subLink = item[key];
                                            return (
                                              subLink &&
                                              Location.pathname.startsWith(
                                                subLink
                                              )
                                            );
                                          })
                                        ? "active subdrop"
                                        : ""
                                        } `}
                                      onClick={() => {
                                        // Keep parent menu open when clicking submenu items
                                        if (!subOpen) {
                                          localStorage.setItem(
                                            "menuOpened",
                                            title?.label
                                          );
                                          setSubopen(title?.label);
                                        }
                                        toggleSubsidebar(item?.label);
                                        closeMobileSidebarIfMobile();
                                      }}
                                    >
                                      {item?.label}
                                      <span
                                        className={
                                          item?.submenu ? "menu-arrow" : ""
                                        }
                                      />
                                    </Link>
                                    <ul
                                      style={{
                                        display:
                                          subsidebar === item?.label
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {item?.submenuItems?.map((items: any) => (
                                        <li key={items.label}>
                                          <Link
                                            to={items?.link}
                                            className={`${subsidebar === items?.label
                                              ? "submenu-two subdrop"
                                              : "submenu-two"
                                              } ${items?.submenuItems
                                                ?.map((link: any) => link.link)
                                                .some((link: string) =>
                                                  Location.pathname.startsWith(
                                                    link
                                                  )
                                                ) ||
                                                Location.pathname.startsWith(
                                                  items?.link
                                                )
                                                ? "active"
                                                : ""
                                              }`}
                                          >
                                            {items?.label}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
